"use strict";

var _App, _App2;
import '@autoguru/overdrive/dist/styles/global/reset.css';
import '@autoguru/overdrive/dist/styles/global/fonts.css';
import { LoggingAgentProvider } from '@autoguru/logs';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { getMfeMountPoint } from 'gdu/dist/lib/mfe';
import { App } from './App';
import { TENANT_NAME } from '@autoguru/global-configs';
import { OverdriveProvider } from '@autoguru/overdrive';
import { SupportedBrowsersBoundary } from '@autoguru/supported-browser-boundary';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AGSupportedBrowsers from '../browsers';
import * as guruConfigs from '../guru.config';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const root = getMfeMountPoint({
  mountDOMId: guruConfigs.mountDOMId,
  projectName: __GDU_APP_NAME__
});
const MFE = () => {
  createRoot(root).render(/*#__PURE__*/_jsx(StrictMode, {
    children: /*#__PURE__*/_jsx(LoggingAgentProvider, {
      children: /*#__PURE__*/_jsx(OverdriveProvider, {
        children: /*#__PURE__*/_jsx(SupportedBrowsersBoundary, {
          browsers: AGSupportedBrowsers,
          children: /*#__PURE__*/_jsx(Router, {
            future: {
              v7_startTransition: true
            },
            children: /*#__PURE__*/_jsxs(Routes, {
              children: [/*#__PURE__*/_jsx(Route, {
                path: TENANT_NAME === 'au-legacy' ? '/' : ':tenant/',
                element: _App || (_App = /*#__PURE__*/_jsx(App, {}))
              }), /*#__PURE__*/_jsx(Route, {
                path: TENANT_NAME === 'au-legacy' ? ':fmoSlug/' : ':tenant/:fmoSlug/',
                element: _App2 || (_App2 = /*#__PURE__*/_jsx(App, {}))
              })]
            })
          })
        })
      })
    })
  }));
};
export default MFE;